



import { DoceboClassroomLocation } from '@/lib/DoceboAPI';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SessionLocation extends Vue {
  @Prop() locations!: DoceboClassroomLocation[];

  @Prop() locationId!: number;

  private get locationName(): string {
    const location = this.locations.find(
      (l) => l.id_location === this.locationId
    );
    return location?.name || '';
  }
}
